import "@splidejs/splide/css/core";

import Navbar from "./components/Navbar";
import ClickLink from "./base/ClickLink";
import ScrollTo from "./base/ScrollTo";
import ReviewsCarousel from "./components/ReviewsCarousel";
import ServiceCarousel from "./components/ServiceCarousel";
import InfinityCarousel from "./components/InfinityCarousel";
import HeaderSlider from "./components/HeaderSlider";
import Articles from "./components/Articles";
import ConsultationForm from "./components/ConsultationForm";
import FilterButton from "./components/FilterButton";
import UploadInput from "./components/UploadInput";
import Collapse from "./base/Collapse";
import Show from "./base/Show";
import TechnologyCarousel from "./components/TechnologyCarousel";
import BasicSlider from "./components/BasicSlider";
import PartnerSlider from "./components/PartnerSlider";
import LogoBoxesSlider from "./components/LogoBoxesSlider";
import TinySliders from "./components/TinySlider";
import ReadMore from "./base/ReadMore";
import Animation from './components/Animation';
import Anchor from './components/Anchor';
import FilterSlider from './components/FilterSlider';
import Modal from './components/Modal';
import TextValidate from './components/TextValidate';
import RespnsiveTable from './components/ResponsiveTable';
import SpecialOfferModal from './components/SpecialOfferModal';
import Flashmessages from './components/Flashmessages';
import SetAltTextForImg from './components/SetAltTextForImg';
import Form from "./base/Form";
import FormZip from "./base/FormZip";
import SpinocoChat from "./base/SpinocoChat";
import SelectFormated from "./components/SelectFormated";
import Editable from "./base/Editable";
import EditableImage from "./base/EditableImage";
import EditableLink from "./base/EditableLink";
import FormAnchor from "./components/FormAnchor";
import MenuBar from "./components/MenuBar";
import CubeeForm from "./components/CubeeForm";

document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));

window.addEventListener('DOMContentLoaded', () => {
    Navbar.init();
    Collapse.init();
    ClickLink.init();
    ScrollTo.init();
    HeaderSlider.init();
    //ReviewsCarousel.init();
    ServiceCarousel.init();
    InfinityCarousel.init();
    TechnologyCarousel.init();
    Articles.init();
    ConsultationForm.init();
    UploadInput.init();
    Show.init();
    BasicSlider.init();
    PartnerSlider.init();
    LogoBoxesSlider.init();
    ReadMore.init();
    TinySliders.init();
    Animation.init();
    Form.init();
    FormZip.init();
    FilterButton.init();
    Modal.init();
    Anchor.init();
    FormAnchor.init();
    SpecialOfferModal.init();
    TextValidate.init();
    RespnsiveTable.init();
    SpinocoChat.init();
    SelectFormated.init();
    Flashmessages.init();
    Editable.init();
    EditableImage.init();
    EditableLink.init();
    SetAltTextForImg.init();
    FilterSlider.init();
    MenuBar.init();
    CubeeForm.init();
});

window.addEventListener('scroll', () => {
    Animation.init();
});
